import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faQrcode } from '@fortawesome/free-solid-svg-icons';
import './ScanAnytime.css';
import scananytimeimage from '../../assets/pageimages/ScanAnytime.webp';

function ScanAnytimeHome() {

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>ScanAnytime</h2>
      </div>
      <div className="main-content">
      <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
          <div className="button-links flex align-middle justify-center bg-gray-500">
            <div className="bottom-buttons-box"><Link to="/scananytime-myqrlist" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="scananytime-bottomlink-style" />My Codes</Link></div>
            <div className="bottom-buttons-box"><Link to="/scan" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="scananytime-bottomlink-style" />Donate</Link></div>
            <div className="bottom-buttons-box"><Link to="/scananytime-mydonationslist" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="scananytime-bottomlink-style" />My Donations</Link></div>
            <div className="bottom-buttons-box"><Link to="/scananytime-myincentivelist" className="top-button-link"><FontAwesomeIcon icon={faStar} className="scananytime-bottomlink-style" />My Incentives</Link></div>
          </div>
        </div>
        <div className="image-container">
        <div className="relative inset-0 flex border border-b-gray-300">
            <img id="scananytime-id" src={scananytimeimage} alt="ScanAnytime Image" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default ScanAnytimeHome;
